import { render, staticRenderFns } from "./embroidery_request.vue?vue&type=template&id=618ebf64&scoped=true&"
import script from "./embroidery_request.vue?vue&type=script&lang=js&"
export * from "./embroidery_request.vue?vue&type=script&lang=js&"
import style0 from "./embroidery_request.vue?vue&type=style&index=0&id=618ebf64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ebf64",
  null
  
)

export default component.exports